import { connect } from 'react-redux';
import { dispatchify } from 'common/utils/utils';
import { toggleSnackBar, toggleModal } from 'state/callers';
import { myAccountSelector } from 'state/selectors/account';
import { repositoriesSelector } from 'state/selectors/repositories';
import ApiTokens from './ApiTokens';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';

const mapStateToProps = state => ({
  repositories: repositoriesSelector(state),
  account: myAccountSelector(state)
});

const mapDispatchToProps = dispatch => ({
  ...dispatchify(dispatch, {
    toggleSnackBar,
    toggleModal
  })
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(ApiTokens, 'API Tokens'));
